/* eslint-disable max-params */
import axios from "axios";
import { appUrl } from "../constants/url-constants";
import { getBifrostInstance } from "../utils/get-bifrost-instance";

const bifrostUserApi = axios.create({
    baseURL: process.env.BIFROST_USER_SERVICE_BASE_URL
});

const bifrostAuthApi = axios.create({
    baseURL: process.env.BIFROST_AUTH_SERVICE_BASE_URL
});

const appAuthApi = axios.create({
    baseURL: appUrl(),
    withCredentials: true
});

const bifrost = getBifrostInstance();

let flowToken = "";

export const BifrostService = {
    sendOtp: async (mobileNumber, countryCode = "+91") => {
        const { codeChallenge } = await bifrost.generatePKCES256();
        const state = {
            deviceId: bifrost.getDeviceId(),
            clientId: bifrost.getClientId(),
            redirectUri: bifrost.getRedirectUri()
        };
        const { data: { flow_token: flowTokenResponse } } = await bifrost.startLoginFlow({
            codeChallenge,
            redirectUri: bifrost.getRedirectUri(),
            state: {
                ...state
            }
        });
        flowToken = flowTokenResponse;
        return await bifrost.sendOtp({
            methodId: "PHONE_OTP",
            identifier: `${countryCode}${mobileNumber}`,
            flowToken: flowTokenResponse
        });
    },
    verifyOtp: async (otp, mobileNumber, countryCode = "+91") => {
        return await bifrost.verifyOtp({
            flowToken,
            code: otp,
            identifier: `${countryCode}${mobileNumber}`,
            methodId: "PHONE_OTP"
        });
    },
    userProfile: (token) => {
        return bifrostUserApi.get("/api/v1/user", {
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`
            }
        });
    },
    introspectToken: async (token) => {
        const response = await bifrostAuthApi.get("/oauth2/introspect", {
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`
            }
        });
        if (response.data && response.data?.data) {
            return { active: response.data?.data?.active || false };
        }
        return { active: false };
    },
    logout: async (token) => {
        await bifrost.logout({ accessToken: token, deviceIds: [bifrost.getDeviceId()] });
    },
    exchangePvtToBifrost: async (token) => {
        const response = await bifrostAuthApi.post("/oauth2/token-exchange", {
            exchange_type: "pvt_to_client",
            client_id: bifrost.getClientId(),
            token,
            session_info: {
                platform: "WEB",
                loginMethod: "sso",
                device_info: {
                    device_id: bifrost.getDeviceId()
                }
            }
        }, {
            headers: {
                "Content-Type": "application/json",
                "x-device-id": bifrost.getDeviceId()
            }
        });

        return response;
    },
    configureBifrostAuth: async (bifrostToken, refreshToken, sessionId, expiresIn, refreshTokenExpiryIn) => {
        const response = await appAuthApi.post("/auth/configure", {
            bifrost_token: bifrostToken,
            refresh_token: refreshToken,
            session_id: sessionId,
            expires_in: expiresIn,
            refresh_token_expiry_in: refreshTokenExpiryIn,
            device_id: bifrost.getDeviceId()
        }, {
            headers: {
                "Content-Type": "application/json"
            }
        });

        return response;
    },
    exchangeCodeToClient: async (authCode) => {
        const response = await bifrostAuthApi.post("/oauth2/token-exchange", {
            exchange_type: "code_to_client",
            code: authCode,
            client_id: bifrost.getClientId(),
            session_info: {
                platform: "WEB",
                loginMethod: "otp",
                device_info: {}
            }
        }, {
            headers: {
                "Content-Type": "application/json",
                "x-device-id": bifrost.getDeviceId()
            }
        });

        return response;
    }
};
